import { makeStyles } from '@material-ui/core/styles';

export const useContainerStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 10,
    border: `1px dashed ${theme.palette.primary.main}`,
    marginTop: 45,
  },
  loadingContainer: {
    display: 'flex',
    justifyContent: 'center',
  },
  loadingImage: {
    height: 80,
    width: 80,
  },
}));
